import sumBy from 'lodash/sumBy';
import { IMPORT_LETTERS } from '../constants';

function customerCount(state = 0, action) {
  switch (action.type) {
    case IMPORT_LETTERS:
      return sumBy(action.payload, 'customers');
    default:
      return state;
  }
}

export default customerCount;
